import { useRouter } from "next/router";
export const OrderBy = () => {
  const router = useRouter();
  const {
    order_by
  } = router.query;
  const orderBy = order_by ? order_by === "min_price" ? "lowest price" : "Highest price" : "recommended";
  return {
    orderBy
  };
};